<template>
      <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Topnav -->
    <!-- <Header /> -->
    <!-- Header -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-2 col-md-3 col-2">
              <h2>Executed Bids</h2>
            </div>
            <div class="col-lg-7 col-md-7 col-5 bid">
               <form class="form-inline dt-filter justify-content-end">
                  <!-- <label for="filter" class="col-form-label">Filter</label> -->
                  <div class="form-group">
                    <label for="filter" class="col-form-label">From</label>
                    <datepicker :disabledDates="disabledDates" v-model="fromDateExport" placeholder="mm/dd/yyyy"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="form-group">
                    <label for="filter" class="col-form-label">To</label>
                    <datepicker :disabledDates="disabledDates" v-model="toDateExport" placeholder="mm/dd/yyyy"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <button :disabled="!fromDateExport || !toDateExport" type="button" @click="exportToExcel()" class="btn btn-warning rounded"><i class="fas fa-download"></i> EXPORT</button>
                </form>
            </div>
             <div class="col-lg-3 col-md-2 col-5 bid">
                <div class="input-group d-inline-flex justify-content-end w-100">
                  <form @submit.prevent="" class="form-inline d-flex justify-content-center mt-0 w-100">
                    <i @click="searchBid()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                    <input v-on:keyup.enter="searchBid" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search Cusip" aria-label="Search">
                    <i  v-if="searchValue" @click="clearSearch()"  class="fas fa-times-circle cursor-pointer"></i>
                  </form>
                </div>                
            </div>
          </div>
          <!-- Card stats -->
        </div>
        <div  class="filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
              <div class="d-flex justify-content-between">
                <h5 class="ml-3">Filters</h5>
                <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                </span>
              </div>
              <div v-if="showFilters">
                <div class="col-lg-12">
                  <form class="row">
                    <div class="form-group">
                      <label for="filter" class="col-form-label">From</label>
                      <datepicker :disabledDates="disabledDates"  v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group">
                      <label for="filter" class="col-form-label">To</label>
                      <datepicker :disabledDates="disabledDates" v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <button @click="searchBid()" type="button" class="btn btn-primary rounded ml-0">Filter</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="container-fluid mt--6">
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                      @click="sort('cusip')">CUSIP/COUPON/DESC</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                      @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                      @click="sort('state')">STATE/<br>INSURER</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'amount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'amount'  ? 'sort-desc' : '']"  
                      @click="sort('amount')">BID PRICE</th>                     
                     <!-- <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tmcPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tmcPrice'  ? 'sort-desc' : '']"  
                      @click="sort('tmcPrice')">TMC PRICE</th> -->
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                      @click="sort('quantity')">PAR <br> VALUE</th>
                       <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                      @click="sort('minQuantity')">MINIMUM <br> QUANTITY</th>
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidKeepCancel'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidKeepCancel'  ? 'sort-desc' : '']"  
                      @click="sort('bidKeepCancel')">MINIMUM QUANTITY <br> BID OPTION</th>
                      <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'successEcn'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'successEcn'  ? 'sort-desc' : '']"  
                      @click="sort('successEcn')">Executed <br> ECN</th>
                       <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidSuccessAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidSuccessAt'  ? 'sort-desc' : '']"  
                      @click="sort('bidSuccessAt')">Executed <br> Time</th>
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedQuantity'  ? 'sort-desc' : '']"  
                      @click="sort('executedQuantity')">Executed <br> Quantity</th>
                  <!--   <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                      @click="sort('yieldSpread')">YIELD <br> SPREAD </th>
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                      @click="sort('minBps')">BPS RANGE <br> MIN/MAX </th>
                      
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'factorRatio'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'factorRatio'  ? 'sort-desc' : '']"  
                      @click="sort('factorRatio')">FACTOR <br> RATIO</th> -->
                    <th 
                      v-if="isAdmin" 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderName'  ? 'sort-desc' : '']"  
                      @click="sort('traderName')">TRADER </th>
                  </tr>
                </thead>
                <tbody class="list">
                   <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="bid in bids" :key="bid.id" @click="getBidDetails(bid)" v-bind:class="{'active-row': bid.isActive}">
                      <td>
                        <span class="cusips">{{bid.cusipVal}}</span>
                        <span class="coupon">{{bid.cusipCoupon | percent(3) }}</span>
                        <span class="desc">{{bid.cusipDescription}}</span>
                      </td>
                      <td class="text-center">
                        <span class="maturity">{{moment(bid.cusipMaturityDate).format("MM/DD/YYYY")}}</span><br>
                        {{bid.cusipCallDate ? moment(bid.cusipCallDate).format("MM/DD/YYYY") : "N/A"}}
                      </td>
                      <td>
                        <span class="state">{{getStateName(bid.cusipStateId)}}</span>
                        <span class="insurer">{{bid.cusipBondInsurer ? bid.cusipBondInsurer : "N/A"}}</span>
                      </td>
                      <td><span class="text-primary">{{bid.amount | currency}}</span>
                      </td>
                      <!-- <td><span class="text-primary">{{bid.bidType == 'YIELD' ? bid.tmcPrice : 'N/A'}}</span> -->

                      <td class="text-center">{{bid.quantity}}</td>
                      <td class="text-center">{{bid.minQuantity}}</td>
                      <td class="text-center">
                        <span>{{bid.bidKeepCancel ? bid.bidKeepCancel : "N/A"}}</span>
                      </td>
                     <td class="text-center">{{bid.successEcn == 'IBP' ? 'BondPoint' : bid.successEcn}}</td>
                     <td class="text-center">{{bid.bidSuccessAt ? moment_timezone(bid.bidSuccessAt).tz('America/New_York').format("MM/DD/YYYY HH:mm:ss") : 'N/A'}} EST</td>
                     <td class="text-center">{{bid.executedQuantity ? bid.executedQuantity : 'N/A'}}</td>
                    
                      <!--  <td class="text-center">
                        <span v-if="bid.bidType == 'YIELD'" class="bid text-success">{{bid.pointToDate}} </span>
                        <span v-if="bid.bidType == 'YIELD'" class="bid text-primary">{{bid.pointToCurve}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'">{{bid.curveYield}}</span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>

                      </td>
                      <td 
                        class="text-center"><span v-if="bid.bidType == 'YIELD'">{{bid.yieldSpread}}</span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'"> MIN {{bid.minBps ? bid.minBps : 0}} / MAX {{bid.maxBps ?  bid.maxBps : 0}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'"> 1 : {{bid.factorRatio || 0}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td> -->
                      <td 
                        v-if="isAdmin" 
                        class="text-center" 
                        @click="getTraderInfo(bid.cognitoSub)">{{bid.traderName}}
                      </td>
                    </tr>
                </tbody>
              </table>
               <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getBidList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <trader-info v-bind:traderInfo="traderData" v-if="modalOpen" @close="modalOpen = false"></trader-info>
      <executed-bid-info 
        v-bind:bid="selectedBid"
        @close="selectedBid = null"
        v-if="selectedBid"
      ></executed-bid-info>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import TraderInfo from "./TraderInfoPopup"
import stateConstants from "@/stateConstants";
import ExecutedBidInfo from "../admin/ExecutedBidInfo";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "executedbids",
   components: {
    // Header,
    // Footer,
    TraderInfo,
    ExecutedBidInfo,
    Datepicker
  },
  data() {
    return {
      accessToken: null,
      bids:[],
      config: config,
      loading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 1,
      sortColumn: "latestDate",
      sortOrder: "DESC",
      traderData:{},
      modalOpen: false,
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      cognitoSub : null,
      stateConstants: stateConstants,
      selectedBid : null,
      fromDate : "",
      toDate : "",
      fromDateExport : "",
      toDateExport : "",
      showFilters : false,
      disabledDates: {
        from : new Date()
      },
    };
  },
  methods: {
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getTraderInfo(cognitoSub){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            cognitoSub,
            auth
        )
        .then(result => {
          this.modalOpen = true;
          this.traderData = result.data;
          this.loading = false;

        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    searchBid(){
      this.getBidList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getBidList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getBidList();
    },
    getBidList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken()  }
      };
      var subId = (!this.isAdmin && this.isTrader) ? this.cognitoSub : "";
      var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      var tDate = this.toDate ? this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
     // console.log(fDate);
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/list?page=" +
            currentPage+
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=SUCCESS"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
             subId+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate,
            auth

        )
        .then(result => {
          console.log(result);
          this.loading = false;
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(bid) {
            bid.isActive = false;
            if(bid.pointToCurve == 'MUNICURVE') bid.pointToCurve  = 'Muni Curve';
            if(bid.pointToCurve == 'TENYEARTREASURRY') bid.pointToCurve  = '10 Year Treasury';
          });
          this.bids = result.data.content;  
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBidDetails(bidSelected){
      this.bids.forEach(function(bid) {
        bid.isActive = false;
      });
      bidSelected.isActive = true;
     // this.selectedBid = bidSelected;
    },
    exportToExcel(){
      this.loading = true;
      var subId = (!this.isAdmin && this.isTrader) ? this.cognitoSub : "";
      var fDate = this.moment(this.fromDateExport).utc().format("YYYY-MM-DD HH:mm:ss");
      var tDate = this.moment(this.toDateExport).utc().format("YYYY-MM-DD HH:mm:ss");
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/excel/report-bids?fromDate="+fDate+"&toDate="+tDate+"&cognitoSub="+subId,
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });

    }    
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
            roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
            roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            this.cognitoSub = authService.getUser().cognitoSub;
            this.fromDate = this.moment().format("MM-DD-YYYY");
            this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
            this.fromDateExport = this.moment().format("MM-DD-YYYY");
            this.toDateExport = this.moment().add(1,'days').format("MM-DD-YYYY");
            //console.log("ff",this.moment().toDate())
            this.getBidList();
          }
        });
        
        
      }
    });

  }
   
  
};
</script>